import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./showcase.css";
import "../../../index.css";
import Button from "../../../components/button/button";
import { useState } from "react";
import PopUpModal from "../../../popUpForms/formModals/popUpFormModal";
import {
  showcaseDate,
  showcaseApplicationDeadlineDate,
  formatDate,
  formatDateWeekday,
  upcomingShowcase,
} from "../../../utils/showcaseDates";
import PopUpFormNotify from "../../../popUpForms/popUpFormNotify";

function Showcase() {
  const [showShowcaseDate, setShowShowcaseDate] = useState(false);
  const [showNotifyMeForm, setShowNotifyMeForm] = useState(false);

  useEffect(() => {
    setShowShowcaseDate(upcomingShowcase);
  }, []);

  const handleNotifyMeForm = () => {
    setShowNotifyMeForm(true);
  };

  return (
    <div>
      <>
      <Helmet>

      <title>Wildfire Innovation Showcase | CWPC</title>

      <meta
      name="description"
      content="The CWPC Wildfire Innovation Showcase brings together innovators, communities, and partners to share solutions for wildfire prevention."
      />

      <link
      rel="canonical"
      href="https://preventwildfire.world/showcase"
      />

      <meta property="og:type" content="website"/>

      <meta
      property="og:title"
      content="Wildfire Innovation Showcase | CWPC"
      />

      <meta
      property="og:description"
      content="Explore and present innovations focused on preventing catastrophic wildfires."
      />

      <meta
      property="og:url"
      content="https://preventwildfire.world/showcase"
      />

      <meta
      property="og:image"
      content="https://preventwildfire.world/assets/og-default.jpg"
      />

      </Helmet>
        <PopUpModal
          activeForm={"notify"}
          formActiveState={showNotifyMeForm}
          setFormActiveState={setShowNotifyMeForm}
        >
          <PopUpFormNotify />
        </PopUpModal>
      </>

      <div className="showcase_page">
        <section id="hero-section" className="section">
          <div className="heading large-screen-limit">
            <h1>Wildfire Innovation Showcase</h1>
            <h2>
              {showShowcaseDate}
              {showShowcaseDate ? formatDate(showcaseDate) : ""}
            </h2>
          </div>
          <div className="photo-credit">Photo credit: BC Wildfire Service</div>
        </section>

        <section className="section" id="invitation-section">
          <div className="section-content-wrapper large-screen-limit">
            <h2>Showcasing Innovations</h2>
            <p>
              The Catastrophic Wildfire Prevention Consortium (CWPC) and Venture
              Starters are hosting an online showcase to connect visionary
              entrepreneurs with impact investors and mission aligned venture
              capital.
            </p>
            <div className="apply-register-block">
              <div className="apply-block">
                <div>
                  <h5>Apply to present and/or nominate wildfire innovators</h5>
                  <p>
                    We welcome a diverse array of innovations that cover a range
                    of technologies and applications, with the goal of bridging
                    critical gaps in wildfire prevention, community resilience
                    and regeneration.
                  </p>
                  <br />
                  <p className="deadline">
                    {showShowcaseDate ? (
                      <>
                        <span>Deadline:</span> <br />
                        <span>
                          {formatDateWeekday(showcaseApplicationDeadlineDate)}{" "}
                          5PM PST
                        </span>
                      </>
                    ) : (
                      <strong>Accepting applications!</strong>
                    )}
                  </p>
                </div>
                <Button
                  smWidth="10rem"
                  mdWidth="12rem"
                  lgWidth="15rem"
                  color="var(--green)"
                  link="https://docs.google.com/forms/d/e/1FAIpQLSeSs3XsYEIguFjQ4i9jBQ9nxmYNmNDnhbv_q4qeOtQzWani4g/viewform"
                  text="Apply to Present"
                />
              </div>
              <div className="register-block">
                <div>
                  <h5>
                    Join us{" "}
                    {showShowcaseDate &&
                      `on ${formatDateWeekday(showcaseDate)}`}{" "}
                    to see innovators with great impact
                  </h5>
                  <p>
                    Hosted by the Catastrophic Wildfire Prevention Consortium
                    (at CrowdDoing), in collaboration with Venture Starters
                  </p>
                  <p>
                    We welcome a diverse array of innovations that cover a range
                    of technologies and applications, with the goal of bridging
                    critical gaps in wildfire prevention, community resilience
                    and regeneration.
                  </p>
                </div>
                <Button
                  smWidth="10rem"
                  mdWidth="12rem"
                  lgWidth="15rem"
                  color="var(--orange)"
                  link={showShowcaseDate && "https://venturestarters.com/"}
                  onClick={handleNotifyMeForm}
                  text={showShowcaseDate ? "Register" : "Notify Me!"}
                />
              </div>
            </div>
          </div>
        </section>
        <section id="showcasing-section" className="section">
          <div className="section-content-wrapper large-screen-limit">
            <h2>Showcasing Innovations</h2>
            <h3>Featuring 7 to 10 trailblazing ventures</h3>
            <div className="showcasing-wrapper">
              <div>
                <p>
                  Ready to present solutions that address critical gaps in
                  community safety, resilience, and regeneration?
                </p>
              </div>
              <div>
                <div className="image">
                  <img src="/images/showcase/drone.jpg" alt="drone" />
                </div>
              </div>
            </div>
            <div className="showcasing-statement">
              <p>
                We invite diverse innovations across technologies, sectors, and
                stages of development, including: insurance, water, vegetation
                management, community engagement, energy, telecommunications,
                and fire management. For example, within fire management, we are
                interested in the solutions below (not all inclusive)
              </p>
            </div>
            <div className="showcasing-wrapper list">
              <div>
                <h5>Fire Applications</h5>
                <ul>
                  <li>Fuel mapping and analysis</li>
                  <li>Forest management and fuel reduction</li>
                  <li>Fire-resistant vegetation and materials</li>
                  <li>
                    Eco-friendly retardants Wildfire management cross-functional
                    systems
                  </li>
                  <li>Home hardening and community resilience</li>
                  <li>
                    Early detection technologies Emergency response and
                    communication
                  </li>
                  <li>
                    Climate/weather modeling Autonomous fire-fighting systems
                  </li>
                </ul>
              </div>
              <div>
                <h5>New Areas of Innovation</h5>
                <ul>
                  <li>
                    Community-Powered Prevention and Engagement Tools: Scalable
                    programs empowering local communities to lead wildfire
                    prevention efforts, translating awareness into concrete,
                    measurable action
                  </li>
                  <li>
                    Eco-Financial Instruments: Novel financial products
                    rewarding fire prevention and sustainable land management
                  </li>
                  <li>
                    Tech-Enabled Social Networks: Digital solutions that
                    facilitate collaboration between communities and experts
                  </li>
                  <li>
                    Regenerative Business Models: Ventures that transform
                    wildfire prevention into thriving, sustainable practices
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section id="demo-section" className="section">
          <div className="section-content-wrapper large-screen-limit">
            <h5>
              Demo your innovation and connect with collaborators at CWPC's
              weekly meetings <br />
              <br />
              <a href="mailto:contact@preventwildfire.world">
                contact@preventwildfire.world
              </a>
            </h5>
            <h5>
              Our April Showcase garnered great reception with over 200 guests
              and 6,500+ views!
            </h5>
            {/* <Button
            className="bg-cornflower-blue"
            onclick="window.open('https://www.youtube.com/watch?v=4jI0sPQ19Cg&ab_channel=CatastrophicWildfirePreventionConsortium', '_blank')"
            
          >
            "View Recent showcase"
          </Button> */}
            <Button
              color="bg-cornflower-blue"
              link="/showcase/presentations"
              text="Previous Showcases"
            />

            {/* <button
            className="bg-cornflower-blue"
            onclick="window.open('https://www.youtube.com/watch?v=W7asMiNSEs4', '_blank')"
          >
            View 1st Showcase
          </button> */}
            <div className="organizers-section">
              <h2>Organizers</h2>
              <div className="organizers-wrapper">
                <div>
                  <h5>Catastrophic Wildfire Prevention Consortium</h5>
                  <p>
                    An international coalition of wildfire experts, startups,
                    institutions, and volunteers dedicated to reducing the risk
                    of catastrophic wildfires. By synergizing a diverse set of
                    innovations—blending new and traditional methods—CWPC works
                    to prevent, mitigate, and adapt to wildfire risks, making
                    communities safer, more resilient, and regenerative.
                  </p>
                </div>
                <div>
                  <h5>Venture Starters</h5>
                  <p>
                    A leading, online networking community for startups and
                    early-stage companies that offers investors, founders,
                    mentors, and service providers a platform to pitch their
                    innovations and gaining positive outcomes for their growing
                    institutions.
                  </p>
                </div>
              </div>
            </div>
            <div className="signature-wrapper">
              <h5>We can’t wait to explore new innovations together!</h5>
              <h5>Best Regards,</h5>
              <div className="signatures">
                <h5>
                  Claudia Brenner <br />
                  Co-CEO, CWPC
                </h5>
                <h5>
                  Bobby Fishkin <br />
                  Co-CEO, CWPC and Co-Founder, CrowdDoing
                </h5>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Showcase;
